import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/report-attendance-details',
    name: 'report-attendance-detail',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/report-attendance-detail/index.vue')
  }
]
